"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_TEXTS = exports.DEFAULT_MAX_WIDTH_COLUMN = exports.MAX_WIDTH_MENU = void 0;
const INT_MAX_WIDTH_MENU = 720;
exports.MAX_WIDTH_MENU = `${INT_MAX_WIDTH_MENU}px`;
exports.DEFAULT_MAX_WIDTH_COLUMN = `${INT_MAX_WIDTH_MENU - 32}px`;
exports.DEFAULT_TEXTS = {
    selectAll: 'Select All',
    clearAll: 'Clear All'
};
//# sourceMappingURL=constants.js.map